<template>
  <footer class="common-footer">
    <p class="copyright">Copyright (C) KDDI CORPORATION. <span v-if="isHoken">Copyright (C) au insurance Co., Ltd.<br/></span>All Right Reserverd.</p>
  </footer>
</template>

<script>
export default {
  name: 'common-footer',
  data() {
    return {
      isHoken: this.$store.getters.getIsHoken
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.common-footer {
  position: relative;
  width: 100%;
  min-height: 40px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.copyright {
  text-align: center;
  font-size: 10px;
  line-height: 1;
}
</style>
